import { AUTH_MAGIC_LINK_LOGIN } from 'portal/constants/Routes';
import AuthCheckYourEmail from 'auth/magic_link/AuthCheckYourEmail';
import AuthCheckYourPhone from 'auth/magic_link/AuthCheckYourPhone';
import React from 'react';

function AuthMagicLinkConfirm({ navigate }) {
  const email = window.AppConfigState?.magic_link?.email;
  const phoneNumber = window.AppConfigState?.magic_link?.phone_number;

  if (email) return <AuthCheckYourEmail navigate={navigate} />;
  if (phoneNumber) return <AuthCheckYourPhone navigate={navigate} />;
  window.location.href = AUTH_MAGIC_LINK_LOGIN;
  return <></>;
}

export default AuthMagicLinkConfirm;
